module.exports = __webpack_public_path__ + "img/br1.0ca0de9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br1.jpg
// module id = yjpP
// module chunks = 0